import { Power0 } from 'gsap'
import AnimatedComponent from './AnimatedComponent'

class SiteFooter extends AnimatedComponent {
  buildTimelineIn () {
    const $el = this.$el
    this.timelineIn
      .staggerFromTo(
        $el.find('.social-links li').get(),
        0.8,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0.15,
        0
      )
      .staggerFromTo(
        $el.find('.nav-footer li').get().reverse(),
        0.8,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0.15,
        0
      )
      .staggerFromTo(
        [
          $el.find('.newsletter-subscribe').find('h3, input, button, .mailchimp-form__terms').get(),
          $el.find('.first-dibs-wrap p').get(),
          $el.find('.colophon').find('.credits, .copyright').get(),
        ],
        0.8,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0.2,
        1
      )
  }
}

export default SiteFooter



// WEBPACK FOOTER //
// ./scripts/components/SiteFooter.js